import Button from "@/components/button/Button"
import { useGeneralContext } from "@/components/context/GeneralContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import { useNavigate } from "react-router"

const { Title, Paragraph } = WebsiteTypography

const AssistanceSentNotice: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { setIsModalDarkOpen } = useModalDarkContext()
  const { navigateLink, setProjectGeometryInfo } = useGeneralContext()
  const navigate = useNavigate()

  const onGoToProject = () => {
    if (!navigateLink) return

    setProjectGeometryInfo(null)
    navigate(navigateLink)
    setIsModalDarkOpen(false)
  }

  return (
    <Row className={"delivery-sent-notice-wrapper"} justify={"center"} style={{ marginTop: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={xxl || xl || lg || md || sm ? 3 : 5} centered className={"form-section-title"}>
          <span>{"Your Assistance Request Has Been Sent\n"}</span>
          <span className={"bold"}>{"Successfully"}</span>
        </Title>

        <DividerWithHex marginBottom={16} marginTop={32} />

        <Paragraph centered style={{ paddingTop: 24 }} color={"white"} size={xxl || xl || lg || md || sm ? "md" : "sm"}>
          {
            "Our team will reach out to you shortly to help complete the application!\n\nPlease note that without the required project geometry, you won’t be able to continue filling out the form just yet. However, all the information you’ve already entered has been safely saved in your project within your profile.\n\nYou’ll be able to complete the remaining steps once everything is resolved."
          }
        </Paragraph>

        <Row justify={"center"} style={{ paddingTop: 40 }}>
          <Col xxl={8} xl={8} lg={8} md={10} sm={14} xs={16}>
            <Button btnType={"primary"} onClick={onGoToProject} text={"Go To Project"} size={"large"} block />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default AssistanceSentNotice
